import { render } from "./AddChankangDialog.vue?vue&type=template&id=3c63ae73&scoped=true&ts=true"
import script from "./AddChankangDialog.vue?vue&type=script&lang=ts"
export * from "./AddChankangDialog.vue?vue&type=script&lang=ts"

import "./AddChankangDialog.vue?vue&type=style&index=0&id=3c63ae73&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c63ae73"]])

export default __exports__